import { render } from "./ListContactMessage.vue?vue&type=template&id=61c1808b&scoped=true"
import script from "./ListContactMessage.vue?vue&type=script&lang=js"
export * from "./ListContactMessage.vue?vue&type=script&lang=js"

import "./ListContactMessage.vue?vue&type=style&index=0&id=61c1808b&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c1808b"]])

export default __exports__